/* template */
<template><div class="hot-city-main" v-if="(locateCity)"><div :style='["height:22px"] | transRpxStyle'></div><div class="city-title">{{title}}</div><mpx-view @tap="handleClick" class="city-container"><mpx-image mode="widthFix" src="https://ut-static.udache.com/webx/sfc/vIFowsTluWuy9ZjCqSrH6_image.png" class="location-icon"></mpx-image><div class="location-item">{{locateCity.city_name}}</div></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m3ca41ea2"}'>
.hot-city-main
  margin-left 17px
  margin-right 14px
  font-size 14px
  font-weight normal
  color #333333
  font-family PingFangSC-Semibold
.city-container
  margin-top 12px
  background #F6F7F8
  border-radius 8px
  font-size 14px
  font-weight 400
  color #000000
  font-family PingFangSC
  height 36px
  box-sizing border-box
  padding 0 4px
  display inline-flex
  width auto
  align-items center
  justify-content center
  min-width calc((100% - 16px) / 3)
  .location-icon
    width 16px
    margin-right 2px
  .location-item
    width auto
.city-item
  height 35px
  line-height 35px
  background #FCFCFD
  border 1px solid #E5E5E5
  border-radius 8px
  text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3ca41ea2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./cityLocation.mpx.js?isComponent&outputPath=components%2FcityLocation3ca41ea2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./cityLocation.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2FcityLocation3ca41ea2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3ca41ea2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/cityLocation3ca41ea2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
